<template>
<div class="editor" style="flex-grow: 1">
  <div 
    style="display: flex; margin: 1.2em 0;" 
    v-for="(value, key) in data" 
    :key="key">
    <!-- data[key]是数组 -->
    <template v-if="data[key].constructor === Array">
      <div class="toggle" :ref="key" @click="toggle">{{isToggle ? '展开' : '收起'}}</div>
      <div style="text-align: center">
        <label style="flex-shrink: 0; font-weight: bold">{{key}}:</label>
        <div class="add-btn" @click="addLine(key, 'unshift')">前添加</div>
        <div class="add-btn" @click="addLine(key, 'push')">后添加</div>
      </div>
      <template v-if="typeof value !== 'object'">
        <textarea 
          v-if="typeof value !== 'boolean'" 
          v-model="data[key]"></textarea>
        <input type="checkbox" v-else v-model="data[key]" />
      </template>
      <template v-else>
        <editor :data="data[key]"></editor>
      </template>
    </template>

    <!-- data[key]不是数组 -->
    <template v-else>
      <label style="flex-shrink: 0;font-weight: bold">{{key}}:</label>
      <template v-if="typeof value !== 'object'">
        <textarea 
          v-if="typeof value !== 'boolean'" 
          v-model="data[key]"></textarea>
        <input type="checkbox" v-else v-model="data[key]" />
      </template>
      <template v-else>
        <editor :data="data[key]"></editor>
      </template>
    </template>
  </div>
</div>
</template>

<script>
import { EventBus } from '../event-bus'
export default {
  name: 'editor',
  props: ['data'],
  data () {
    return {
      isToggle: false
    }
  },
  methods: {
    addLine (key, type) {
      EventBus.$emit('addLine', key, type)
    },
    toggle (e) {
      this.isToggle = !this.isToggle
      if (this.isToggle) {
        e.currentTarget.nextElementSibling.nextElementSibling.style.height = "100px"
        e.currentTarget.nextElementSibling.nextElementSibling.style.overflow = "auto"
      } else {
        e.currentTarget.nextElementSibling.nextElementSibling.style.height = "auto"
      }
    }
  }
}
</script>

<style scoped>
.editor {
  background: #fff;
  cursor: default;
}
.editor .add-btn {
  cursor: pointer;
  box-sizing: border-box;
  width: 60px;
  height: 30px;
  padding: 0 5px;
  margin: 0 10px;
  border-radius: 4px;
  background: #f38c1d;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
label {
  padding-right: 10px;
}
textarea, input {
  font-size: 15px;
  font-weight: bold;
  width: 80%;
  padding: 5px 10px;
  box-sizing: border-box;
  border-radius: 5px;
  border-width: 2px;
  border-color: #f5be83;
}
.toggle {
  height: 30px;
  border-radius: 3px;
  font-size: 14px;
  padding: 5px;
  background: #f5be83;
  color: #fff;
}
</style>
